import React from 'react';

import { getOptimizedImgSrc } from './getOptimizedImgSrc';

interface Props {
  src: string;
  width: number;
  className?: string;
}
export const SimpleResponsiveImage: React.FC<Props> = ({ src, width, ...props }) => {
  const defaultScrOptimized = getOptimizedImgSrc({ src, width });
  return (
    <picture {...props}>
      <source
        type="image/avif"
        media="(-webkit-min-device-pixel-ratio: 1.5)"
        srcSet={`${getOptimizedImgSrc({
          src,
          width: width * 2,
          quality: 40,
          format: 'avif',
        })} ${width * 2}w`}
        sizes={`${width}px`}
      />
      <source
        type="image/webp"
        media="(-webkit-min-device-pixel-ratio: 1.5)"
        srcSet={`${getOptimizedImgSrc({
          src,
          width: width * 2,
          quality: 40,
          format: 'webp',
        })} ${width * 2}w`}
        sizes={`${width}px`}
      />
      <source
        type="image/avif"
        srcSet={`${getOptimizedImgSrc({
          src,
          width,
          format: 'avif',
        })} ${width}w`}
      />
      <source
        type="image/webp"
        srcSet={`${getOptimizedImgSrc({
          src,
          width,
          format: 'webp',
        })} ${width}w`}
      />
      <img src={defaultScrOptimized} width="100%" />
    </picture>
  );
};
